import axios from "axios";

export default axios.create({
  baseURL: "https://orientws.uz",
  // baseURL: "http://localhost:80",
  // baseURL: "http://192.168.0.222:80"
});
